import type { CSSProperties, HTMLAttributes, ReactNode } from 'react'
import styles from './Card.module.css'

export type CardPadding = 'sm' | 'md' | 'lg' | 'xl'

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  header?: ReactNode
  footer?: ReactNode
  accent?: string
  gradientBorder?: boolean
  interactive?: boolean
  padding?: CardPadding
}

export function Card({
  header,
  footer,
  accent,
  gradientBorder,
  interactive,
  padding = 'lg',
  children,
  className,
  style,
  ...props
}: CardProps) {
  const classes = [
    styles.card,
    styles[`pad-${padding}`],
    interactive && styles.interactive,
    gradientBorder && styles.gradientBorder,
    className,
  ].filter(Boolean).join(' ')

  const cardStyle = accent
    ? { '--card-accent': accent, ...style } as CSSProperties
    : style

  return (
    <div className={classes} style={cardStyle} {...props}>
      {header && <div className={styles.header}>{header}</div>}
      <div className={styles.body}>{children}</div>
      {footer && <div className={styles.footer}>{footer}</div>}
    </div>
  )
}
